<template>
  <v-container xs12 fluid class="pt-0">
    <!--<v-card class="pa-2 card-r pb-4 shadow-1">-->
      <v-toolbar class="tow-clor-1 card-r pl-3 text-white">
        <div class="text-xs-left f-20">{{$t('dashboard_page.title')}}</div>
      </v-toolbar>
      <v-container fluid grid-list-xl class="pa-0">
      <v-layout wrap>
        <v-flex xs12 class="pa-2">
          <v-alert
            :value="true"
            type="error"
            v-if="Verification_Message"
          >
            {{Verification_Message}}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-container fluid grid-list-xl class="pa-0">
        <v-layout row wrap class="Content3 text-xs-center">
          <v-flex d-flex lg4 sm6 xs12>
              <v-card class="pa-1 card-r">
                <v-card to="/students" class="shadow-1 card-r pa-3 tow-clor-4 white--text topborder" flat xs12 sm6>
                  <br>
                  <v-icon class="white--text">fas fa-graduation-cap</v-icon>
                  <p class="mt-0 mb-0 text-xs-center font-weight-medium subheading font-weight-light">{{$t('dashboard_page.widget1_title')}} </p>
                  <span class="display-0.75 text-xs-center headline font-weight-bold">{{studentData.length}} </span>
                </v-card>
              </v-card>
          </v-flex>

          <v-flex d-flex lg4 sm6 xs12>
            <v-card class="pa-1 card-r">
            <v-card to="/teachers" class="card-r shadow-1 pa-3 tow-clor-2 cyan white--text topborder" flat xs12 sm6>
              <br>
              <v-icon class="white--text">fas fa-chalkboard-teacher</v-icon>
              <p class="mt-0 mb-0 text-xs-center font-weight-medium subheading font-weight-light">{{$t('dashboard_page.widget2_title')}}</p>
              <span class="display-0.75 text-xs-center headline font-weight-bold">{{teacherData.length}} </span>
            </v-card>
            </v-card>
          </v-flex>

          <v-flex d-flex lg4 sm6 xs12>
            <v-card class="pa-1 card-r">
            <v-card to="/totalearnings" class="card-r shadow-1 tow-clor-3 green accent-4 white--text pa-3 topborder" flat xs12 sm6>
              <br>
              <v-icon class="white--text">fas fa-credit-card</v-icon>
              <p class="mt-0 mb-0 text-xs-center font-weight-medium subheading font-weight-light">{{$t('dashboard_page.widget3_title')}} </p>
              <span class="display-0.75 text-xs-center headline font-weight-bold">$ {{ totalEarning.total_income_from_students }} </span>
            </v-card>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout row>
        <v-flex xs12>
          <Charts></Charts>
        </v-flex>
      </v-layout>

    </v-container>
    <!--</v-card>-->
  </v-container>
</template>

<script>
import api from "@/utils/backend-api"
/* eslint-disable */
  import Charts from './Charts'
  import Addclasses from './AddClasses'
  import { mapState ,dispatch, mapActions } from "vuex"


export default {
  name: "Home",
  data:() =>({
    studentData:'',
    teacherData:'',
    adminEarningAmount: '',
    Verification_Message:''
  }),
  components: {
    Addclasses,
    Charts
  },

  methods: {
      ...mapActions("getStudentData","getTeacherData","getTotalEarning")
    },

  created:function(){

    api.postData('viewProfile')
      .then(res=>{
        let verify=res.data.email_verify
        if(verify!=1){
          this.Verification_Message=this.$t('dashboard_page.alert_messages.mail_unverified')
        }
      })
      Store.dispatch('getStudentData');
          setTimeout(() => {
              this.studentData = Store.state.studentData;
              Store.dispatch('getTeacherData');
              this.teacherData = Store.state.teacherData;
              Store.dispatch('getTotalEarning');
              // this.totalEarning = Store.state.totalEarning;
          }, 2500);
      },

    computed:{
        ...mapState({
            tearcherData:"teacherDateObject",
            // studentData:"studentChartDate",
            areaStatisticData:"earningChartData",
            totalEarning:"totalEarning",
        })

    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue